import { LS_REGULATION_SELECTED_KEY } from "../../../core/constants/common";

/** Regulation id for anomaly API calls — always from global regulation context. */
export const resolveAnomalyRegulationId = (glbRegulation) =>
  glbRegulation?.id ?? localStorage.getItem(LS_REGULATION_SELECTED_KEY) ?? "";
